var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30.117 35.1307C26.1234 41.6231 19.5865 41.6231 15.5911 35.1307C11.5941 28.6384 3.59028 17.0741 1.06358 11.6624C-1.46312 6.25058 0.340145 7.0845e-07 8.32909 0H37.3808C45.3714 -7.08603e-07 48.6399 5.17 44.6428 11.6624C40.6475 18.153 34.1106 28.6384 30.117 35.1307Z","fill":"url(#paint0_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"22.8543","y1":"-236.553","x2":"22.8543","y2":"39.9999","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#15100F","key":0}),React.createElement("stop",{"offset":"0.755208","stopColor":"#97021B","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#B70322","key":2})]))]);
}

ArrowInline.defaultProps = {"width":"47","height":"40","viewBox":"0 0 47 40","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
